import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import { clearToken } from '../utilities/auth';
import { authFetch } from '../services/authFetch';
import { logOut } from '../redux/authSlice';
import Footer from './Footer';

import './Dashboard.scss';

function Dashboard(props) {
    const dispatch = useDispatch();

    const activeView = useSelector(state => state.view.activeView);
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [tableauAuth, setTableauAuth] = useState({});
    const tableauPlaceholderEl = useRef(null);

    const handleLogOut = useCallback(() => {
        clearToken();
    
        dispatch(logOut());
    }, [dispatch]);

    useEffect(() => {
        setError(null);
        setIsLoaded(false);
        setTableauAuth({});

        if (tableauPlaceholderEl.current) {
            tableauPlaceholderEl.current.innerHTML = "";
        }

        if (activeView === null) {
            return;
        }
        
        authFetch(`${window.AnalyticsPortalConfig.apiAddress}/TableauSessions`, {
            method: "POST"
        })
            .then(result => {
                if (!result.ok) {
                    if (result.status === 401) {
                        throw new Error('401');
                    }

                    throw new Error('Response not OK.');
                }
                
                return result.json()
            })
            .then((result) => {
                if (result.isSuccessful) {
                    setError(null);
                    setIsLoaded(true);

                    let genericUserParams = '';

                    if (result.isGenericUser) {
                        genericUserParams = `
                            <param name='alerts' value='no' />
                            <param name='customViews' value='no' />
                            <param name='subscriptions' value='no' />`;
                    }

                    tableauPlaceholderEl.current.innerHTML = `
                        <object class='tableauViz' width='100%' height='100%'>
                            <param name='host_url' value="${result.tableauWebBaseAddress}/" />
                            <param name='embed_code_version' value='3' />
                            <param name="ticket" value="${result.secureToken}" />
                            <param name='name' value="${activeView.viewName}" />
                            <param name='tabs' value='no' />
                            <param name='toolbar' value='yes' />
                            <param name='showShareOptions' value='false' />
                            <param name='showAppBanner' value='false' />
                            ${genericUserParams}
                        </object>`;

                    setTableauAuth(result);
                }
                else {
                    setError({ message: result.errorMessage });
                    setIsLoaded(true);
                    setTableauAuth({});
                }
            })
            .catch((error) => {
                console.error(error);

                if (error.message === '401') {
                    handleLogOut();

                    return;
                }

                setError(error);
                setIsLoaded(true);
                setTableauAuth({});
            });
    }, [activeView, handleLogOut]);

    useEffect(() => {
        if (!tableauAuth.tableauWebBaseAddress) {
            return;
        }

        const script = document.createElement('script');
      
        script.src = `${tableauAuth.tableauWebBaseAddress}/javascripts/api/viz_v1.js`;
        script.async = true;
      
        document.body.appendChild(script);
      
        return () => {
            document.body.removeChild(script);
        }
    }, [tableauAuth.tableauWebBaseAddress]);

    if (error) {
        return (
            <>
                <div className={clsx(!props.isPhone && "dashboard-container",
                    props.isPhone && "dashboard-container-phone",
                    "w-100 h-100 d-flex flex-column align-items-center justify-content-between")}>
                    <div></div>
                    <div className="alert alert-danger" role="alert">Error: {error.message}</div>
                    <Footer />
                </div>
            </>
        );
    } else if (!isLoaded) {
        return (
            <div className={clsx(!props.isPhone && "dashboard-container",
                props.isPhone && "dashboard-container-phone",
                "w-100 h-100 d-flex flex-column align-items-center justify-content-between")}>
                <div></div>
                <div className="alert alert-info" role="alert">Loading...</div>
                <Footer />
            </div>
        );
    } else {
        return (
            <div className={clsx(!props.isPhone && "dashboard-container",
                props.isPhone && "dashboard-container-phone",
                "w-100 h-100 d-flex flex-column align-items-center")}>
                <div ref={tableauPlaceholderEl}
                    className="w-100 h-100"></div>
                <Footer />
            </div>
        );
    }
}

export default Dashboard;